import { IonButton } from "@ionic/react";
import clsx from "clsx";
import React, { forwardRef } from "react";
import "./iconButton.scss";

export interface IIconButtonProps extends React.ComponentPropsWithoutRef<typeof IonButton> { }

export const IconButton = forwardRef<HTMLIonButtonElement, IIconButtonProps>((props, forwardedRef) => {
    const { fill = "clear", size = "small", ...restProps } = props;

    return (
        <IonButton
            {...restProps}
            ref={forwardedRef}
            fill={fill}
            size={size}
            className={clsx("icon-button", props.className)}
        />
    );
});
